import '../stylesheets/Years.css';

export function Years({ 
    years, 
    currentYear, 
    editSingleYear, 
    deleteSingleYear, 
    onChangeCurrentYear 
}) {
    return (
        <div className='Years'>
            {
                years.map(item => (
                    <div
                        key={item._id}
                        onClick={() => onChangeCurrentYear(item.year)}
                        className={currentYear === item.year ? 'year active' : 'year'}
                    >
                        <p className='text'>{item.year}</p>

                        <div className='controls'>
                            <i 
                              className='fa-solid fa-pen-to-square' 
                              onClick={() => editSingleYear(item.year)}
                            />

                            <i
                                className='fa-solid fa-trash'
                                onClick={() => deleteSingleYear(item.year)}
                            />
                        </div>
                    </div>
                ))
            }
        </div>
    )
}
